"use client"
import { Button, Col, Radio } from "antd"
import { forwardRef, useImperativeHandle, useRef } from "react"
import PopupMobile, { PopupMobileRef } from "@/components/common/PopupMobile"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { flightActions } from "@/lib/redux/features/flight/reduce"
import { cabinClasses } from "@/constants/flight/cabinClass"
import { useTranslation } from "react-i18next"


export type PopupSelectClassRef = {
  open: () => void,
  close: () => void,
}

type PopupSelectClassProps = {

}

const PopupSelectClass = forwardRef<PopupSelectClassRef, PopupSelectClassProps>(
  (props, ref) => {
    const refPopupMobile = useRef<PopupMobileRef>(null)
    const dispatch = useAppDispatch()
    const cabinClass = useAppSelector(state => state.flight.cabinClass)
    const { t } = useTranslation()

    useImperativeHandle(ref, () => {
      return {
        open: () => refPopupMobile.current?.open(),
        close: () => refPopupMobile.current?.close()
      }
    }, [refPopupMobile.current])

    return (
      <PopupMobile
        headerProps={{
          title: "Seat class",
        }}
        ref={refPopupMobile}
        height={'28rem'}
      >
        <Col span={24}>
          <Radio.Group
            size='large'
            className="select__class"
            value={cabinClass}
            onChange={(e) => {
              dispatch(flightActions.selectCabinClass(e.target.value))
            }}
          >
            <Radio value={cabinClasses.Economy.code} className="select__class--item">{t(cabinClasses.Economy.name)}</Radio>
            <Radio value={cabinClasses.Business.code} className="select__class--item">{t(cabinClasses.Business.name)}</Radio>
            <Radio value={cabinClasses["First Class"].code} className="select__class--item">{t(cabinClasses["First Class"].name)}</Radio>
            <Radio value={""} className="select__class--item">{t("common.all")}</Radio>
          </Radio.Group>
        </Col>
        <Col span={24}>
          <Button onClick={() => refPopupMobile.current?.close()} type='primary' block size='large'>
            Xong
          </Button>
        </Col>
      </PopupMobile>
    )
  })

PopupSelectClass.displayName = 'PopupSelectClass'

export default PopupSelectClass